export default "__VITE_ASSET__bdd9f23f__"